export default {
    customer: "مشتری",
    account_number: "نمبر ثبت",
    dashboard: "داشبورد",
    customers: "مشتریان",
    externals: "مشتریان تصادفی",
    daily_transactions: "معاملات",
    sailors: "فروشنده ها",
    branchs: "نمایندگی ها",
    staffs: "کارمندان",
    banks: "بانک ها",
    staff: "کارمند",
    income: "عاید",
    incomes: "عواید",
    shareholders: "سهام داران",
    shareholder: "سهام دار",
    expense: "مصرف",
    expenses: "مصارف",
    branch_accounts: "حسابات شرکت",
    report: "گزارش",
    reports: "گزارشات",
    company_report: "گزارشات شرکت",
    settings: "تنظیمات",
    male: "مرد",
    female: "زن",
    single: "مجرد",
    married: "متاهل",
    users: "کاربران",
    role: "رول",
    roles: "رول ها",
    user: "کاربر",
    all_settings: "تمام تنظیمات",
    date: "تاریخ میلادی",
    payment_type: "نوعیت رسید",
    transaction_no: "نمبر معامله",
    credit: "رسید",
    credits: "رسید ها",
    credit_number: "نمبر رسید",
    debit: "برداشت",
    debits: "برداشت ها",
    debit_number: "نمبر برداشت",

    exchange: "تبادله",
    exchanges: "تبادلات",
    exchanger: "تبادله کننده",
    exchange_number: "نمبر تبادله",

    to: "تا",
    from: "از",
    transfer: "حواله",
    form_number: "نمبر حواله",
    transfers: "حواله جات",
    transfer_src: "ارسال کننده ",
    send_transfer: "ارسال حواله",
    submit_transfer: "اجرا شد",
    transfer_number: "نمبر حواله",
    send_transfers: "حوالات ارسالی",
    transfer_not_done: "اجرا نشده.",
    transfer_done: "اجرا شد",
    receive_transfers: "حوالات دریافتی",
    receive_transfer: "دریافت حواله",

    balance: "بیلانس",
    balance_summery: "خلاصه معلومات",
    number: "شماره",
    other_currencies: "دیگر اسعار",
    description: "ملاحظات",
    amount: "مقدار",
    total: "مجموع",
    money_type: "نوعیت پول",
    rate: "نرخ",
    old_balance: "بیلانس قبلی",
    current_balance: "بیلانس فعلی",
    return: "برگشت",
    new_record: "رکورد جدید",
    edit_record: "ویرایش رکورد",
    search: "جستجو",
    contact: "کانتکت",
    agency: "نمایندگی",
    agencies: "نمایندگی ها",
    actions: "عملیه ها",
    name: "اسم",
    middle_name: "اسم وسطی",
    first_name: "اسم",
    last_name: "تخلص",
    backup: "نسخه پشتیبان",
    save_succeed: "عملیه موفقانه صورت گرفت.",
    wrong_input: "لطفا فیلدها را اصلاح کنید. ورودی ها درست نمی باشد.",

    daily_rate: "نرخ روزانه",
    new_daily_rate: "نرخ جدید",
    password: "رمز عبور",
    old_password: "رمز قبلی",
    new_password: "رمز جدید",
    accept_password: "تایید رمز",
    account: "حساب",
    accounts: "حسابات",
    account_name: "اسم حساب",
    new_account: "حساب جدید",
    debited_account: "حساب کسر شده",
    type: "نوعیت",
    action_type: "عملیه",
    c2c: "انتقال مشتری به مشتری",
    cash: "پول نقد",
    bank: "بانک",
    sail_money: "فروش",
    buy_money: "خرید",
    borrow_total: "مجموع پرداختنی",
    loan_total: "مجموع دریافتنی",
    cash_accounts: "پول نقد",
    bank_accounts: "حسابات بانکی",
    part: "بخش",
    commissions: "کمیشن ها",
    commission: "کمیشن",
    view: "مشاهده",
    edit: "ویرایش",
    add: "افزود",
    delete: "حذف",
    customer_account: "حساب مشتری",
    receiver_account: "حساب دریافتی",
    sender_account: "حساب ارسالی",
    receiver: "دریافت کننده",
    sender: "ارسال کننده",
    branch_account: "حسابات نمایندگی",
    father_name: "اسم پدر",
    identity_number: "نمبرتذکره",
    occupation: "وظیفه",
    exchange_to: "تبادله به",
    exchange_rate: "نرخ تبادله",
    sailor: "فروشنده",
    edit_bill: "ویرایش رکورد",
    status: "وضعیت",
    currency: "واحد پولی",
    currencies: "واحد های پولی",
    currency_worth: "ارزش واحد پولی",
    from_date: "از تاریخ",
    to_date: "تا تاریخ",
    profile: "پروفایل",
    id: "شناسه",
    history: "تاریخچه",
    costs: "مصارف",
    email: "ایمیل",
    address: "آدرس ",
    //customers
    delete_title: "حذف ریکورد",
    delete_alert: "آیا مطمئن هستید که رکورد  مورد نظر را حذف کنید؟",
    delete_succeed: "اطلاعات موفقانه حذف شد.",
    save: "ثبت",
    personal_info: "اطلاعات شخصی",
    title: "عنوان",
    //================================================================
    company: "شرکت",
    companies: "شرکت ها",
    pure_profits: "مفاد خالص",
    current_money: "پول نقد",
    company_financial_report: "راپور های مالی",
    login: "ورود",
    logout: "خروج",
    backups: "بکاپ",
    file: "فایل",
    size: "حجم",
    old_rate: "نرخ قبلی",
    current_rate: "نرخ فعلی",
    rate_incomes: "عواید نرخ",
    daily_profits: "مفاد روزانه",
    updated_at: "آخرین آپدیت",
    sale_currency: "فروش ",
    buy_currency: "خرید",
    action: "عملیه",
    rate_table: "جدول نرخ",
    received_money_type: "نوعیت رسید",
    a2a_transfers: "انتقالات",
    transaction_transfers: "انتقالات",
    credit_amount: "مبلغ رسید",
    debit_amount: "مبلغ برداشت",
    exchange_amount: "مبلغ تبادله",
    transfer_amount: "مبلغ انتقال",
    gam: "پرداخت کننده",
    baqi: "دریافت کننده",
    currency_loan: "باقیات",
    last_form_number: "آخرین نمبر",
    bill_number: "Bill#",
    cleared: "تصفیه شده",
    forgot_password: "رمز تان را فراموش کردید?",
    login_error: "اسم کاربری یا رمز عبور اشتباه می باشد.",
    tazkira: "نمبرتذکره/پاسپورت",
    new_customer: "مشتری جدید",
    external_customer: "مشتری تصادفی",
    date_of_birth: "تاریخ تولد",
    place_of_birth: "محل تولد",
    nationality: "ملیت",
    gender: "جنسیت",
    marital_status: "حالت مدنی",
    permanent_address: "آدرس اصلی",
    current_address: "آدرس فعلی",
    official_address: "آدرس رسمی",
    phones: "تلفون",
    nature_of_business: "نوعیت تجارت",
    monthly_income: "عاید ماهوار",
    source_of_income: "منبع عایداتی",
    monthly_turnover: "حجم معاملات ماهوار",
    tazkira_no: "نمبر تذکره",
    passport_no: "نمبر پاسپورت",
    issuer_place: "محل صدور",
    issue_date: "تاریخ صدور",
    expire_date: "تاریخ ختم",
    tin_number: "نمبر TIN",
    tenure: "مدت وظیفه",
    current_designation: "شغل فعلی",
    previous_designation: "شغل قبلی",
    risk_profile: "میزان ریسک",
    kyc_notes: "توضیحات KYC",
    next_kyc_date: "تاریخ KYC بعدی",
    kyc_updated_date: "آخرین آپدیت KYC",
    reg: "REG",
    reg_no: "کد مشتری",
    reg_date: "تاریخ ثبت ",
    personal_details: "مشخصات فردی",
    resident_status: "وضعیت سکونت",
    resident: "مقیم",
    non_resident: "خارج از کشور",
    contact_details: "اطلاعات شخص رابط",
    profession_details: "اطلاعات شغلی",
    individuals: "مشتریان انفرادی",
    corporates: "مشتریان شرکتی",
    corporate_details: "اطلاعات مشتری شرکتی",
    area_of_services: "Area of Services",
    corporate_name: "اسم شرکت",
    business_address: "آدرس دفتر",
    domicile_address: "آدرس اقامت",
    license_no: "نمبر لایسنس",
    contact_person_name: "اسم رابط",
    director: "سهام دار",
    directors: "سهام داران",
    established_date: "تاریخ تاسیس",
    corporate_type: "نوعیت تجارت",
    license_issue_date: "تاریخ صدور",
    license_expire_date: "تاریخ ختم",
    contact_person_details: "اطلاعات شخص رابط",
    incorporation: "الحاق",
    incorporation_date: "تاریخ الحاقی",
    reg_address: "آدرس راجستر کننده.",
    company_phones: "تلفون شرکت",
    company_email: "ایمیل شرکت",
    designation: "تخصیص",
    reg_name: "اسم ثبت",
    add_director: "افزودن مدیر",
    tazkira_no_or_p: "نمبر تذکره / پاسپورت",
    cif: "اطلاعات مشتری انفرادی",
    individual_cif_title: "ثبت اطلاعات مشتری انفرادی :",
    receipt_form: "فورم رسید",
    tr: "نمبر معامله",
    units: "تعداد",
    total: "مجموع",
    time: "زمان",
    no: "نمبر",
    cash_receipt_form: "فورم رسید ",
    cash_receipts: "رسید ها",
    cash_receipt_title: "پارچه رسید پول به منظور تبادله / ارسال حواله",
    cash_payments: "پرداخت ها",
    cash_payment_form: "فورم پرداخت ها",
    cash_payment_title: "پارچه پرداخت پول به منظور تبادله / ارسال حواله",
    exchange_form: "فورم تبادله",
    exchanged_amount: "مبلغ تبادله",
    full_name: "اسم کامل",
    doc_type: "نوعیت سند",
    doc_no: "نمبر اسناد",
    purpose_of_exchange: "هدف از تبادله",
    source_of_fund: "منبع عایداتی",
    exchange_bill_title: "پارچه تبادله",
    sale_account: "حساب فروش",
    buy_account: "حساب خرید",
    docno: "نمبر سند",
    file_max_notation: "حجم فایل باید کمتر از 10mb باشد.",
    files: "فایل ها",
    passport: "پاسپورت",
    tazkira: "تذکره",
    license: "لایسنس",
    a2a_transfer_slip: "پارچه انتقال حساب به حساب",
    a2a_form: "فورم انتقال حساب به حساب",
    send_remittance_form: "فورم ارسال حواله",
    receive_remittance_form: "فورم دریافت حواله",
    relationship: "نسبت دریافت کننده",
    purpose_of_transaction: "هدف از معامله",
    sender_details: "اطلاعات ارسال کننده",
    receiver_details: "اطلاعات دریافت کننده",
    source: "منبع",
    destination: "مقصد",
    destination_currency: "واحد پولی مقصد",
    sender_currency: "واحد پولی",
    receiver_currency: "واحد پولی دریافت کننده",
    remittance_details: "جزییات حواله",
    send_transfer_slip: "پارچه ارسال حواله",
    receive_transfer_slip: "پارچه دریافت حواله",
    RefNo: "RefNo",
    receiver_address: "آدرس دریافت کننده",
    branches: "نمایندگی ها",
    received_transfers: "حوالات دریافتی",
    system_accounts: "حسابات شرکت",
    incomes: "عواید",
    transaction_details: "جزیات معامله",
    received_account: "حساب جمع ",
    customer_details: "مشخصات مشتری",
    general_ledger: "لیست حسابات",
    lctr_report: "راپور معاملات بزرگ",
    unauthorized_route: "ببخشید! شما اجازه دسترسی به این مسیر را ندارید",
    notfound_route: "ببخشید! مسیر مورد نظر یافت نشد.",
    go_back: "برگشت",
    view_accounts: "مشاهده حسابات",
    change_rate: "تغییر نرخ",
    registration: "اشخاص و شرکتها",
    remittance: "حواله",
    remittances: "حواله جات",
    paid_account: "حساب پرداختی",
    start_date: "شروع",
    code: "کد",
    branch: "نمایندگی",
    end_date: "ختم",
    branch_code: "کد نمایندگی",
    corporates_report: "گزراش مشتریان شرکتی",
    individuals_report: "گزارش مشتریان انفرادی",
    corporates_report: "گزارش مشتریان شرکتی",
    individuals_report: "گزارش مشتریان انفرادی",
    exchanges_report: "گزارش تبادلات",
    shareholder: "سهام دار",
    shareholders: "سهام داران",
    other_branches: "سایر نمایندگی ها",
    income_statement: "صورت حساب مفاد و ضرر",
    balance_sheet: "بیلانس شیت",
    exchanges_profit: "مفاد تبادلات",
    commissions_profit: "مفاد کمیشن ها",
    sale_to_base_rate: "نرخ ارز فروش به USD",
    buy_to_base_rate: "نرخ ارز خرید به USD",
    profit: "مفاد",
    amount_in_word: "به حروف",
    commission_in_word: "کمیشن به حروف",
    avg_rate: "نرخ میانگین",
    system: "نقد", // Just for Account type
    liability: "بدهی",
    equity: "سهام",
    asset: "دارایی",
    fixed_assets:"دارایی های ثابت",
    capital: "سرمایه",
    account_group: "گروپ حساب",
    net_income: "عاید خالص",
    base_rate: "نرخ به دالر",
    view_all_branches_report: "دسترسی به همه نمایندگی",
    transactions_report: "گزارش معاملات",
    deleted_at: "زمان حذف",
    avr_exchanged: "معادل میانگین",
    received_by: "دریافت شده توسط",
    total_debit: "مجموع کاهش",
    total_credit: "مجموع افزایش",
    available_balance: "موجودی فعلی",
    new_customer: "مشتری جدید",
    disable_back_date: "مسدود کردن تاریخ گذشته",
    account_to_search: "بیلانس حساب",
    app_shortcuts: "میانبر های برنامه",
    payables: "طلب داران",
    receiveables: "قرض داران",
    expose_report: "گزارش پیش خرید",
    exposed_amount: "کل پیش خرید",
    opening_balance: "بیلانس اولیه",
    persian_date: "تاریخ شمسی",
    accounts_balance: "بیلانس حسابات",
    external: "مشتری تصادفی",
    individual: "مشتری انفرادی",
    corporate: "مشتری شرکتی",
    closing_balance: "بیلانس قبلی",
    full_details: "مشخصات کامل",
    fa_name: "اسم فارسی",
    locked_until: "قفل",
    buy_currency_details: "ارز خریداری شده",
    sale_currency_details: "ارز فروخته شده",
    no_transaction_found: "هیچ رکوردی تا به حال ثبت نشده است.",
    ccif: "فورم مشخصات شرکت ها (CCIF)",
    icif: "فورم مشخصات اشخاص (ICIF)",
    customer_sign: "امضأ مشتری",
    cashire_sign: "خزانه دار",
    approved_by: "مدیر",
    corporate_reg_form: "فورم ثبت اطلاعات مشتری شرکتی",
    unsave_alert: "شما تغییرات ثبت نشده دارید! آیا میخواهید  صفحه را ترک کنید؟",
    delete_record: "حذف رکورد",
    credit_description: "رسید پول از درک ",
    debit_description: "پرداخت پول به ",
    into: " در حساب",
    buy: "خرید",
    sale: "فروش",
    rate_of: "به نرخ",
    transfered_from: "انتقال از حساب ",
    transfered_to: " به حساب",
    all: "همه",
    deleted: "حذف شده ها",
    all_currencies: "تمامی اسعار",
    total_assets: "کل دارایی",
    total_liabilities: "کل بدهی",
    into: " در حساب",
    purchase_amount: "مقدار خرید",
    sale_amount: "مقدار فروش",
    cic: "هر سه",
    credit_description: "رسید در حساب مشتری",
    from_sender: "از طرف",
    to_receiver: "برای",
    with_amount_of: "به مبلغ",
    with_transafer_no: "به نمبر حواله",
    total_income: "مجموع عواید",
    total_expense: "مجموع مصارف",
    afn_equalient: "معادل افغانی",
    usd_equalient: "معادل دالر",
    branches_receivables: "طلب نمایندگی ها",
    branches_payables: "قروض نمایندگی ها",
    individuals_receivables: "طلب مشتریان انفرادی",
    individuals_payables: "قروض مشتریان انفرادی",
    customers_receivables: "طلب مشتریان",
    customers_payables: "قروض مشتریان",
    corporates_receivables: "طلب مشتریان شرکتی",
    corporates_payables: "قروض مشتریان شرکتی",
    shareholders_payables: "سهام داران",
    transferred_to: "به",
    view_dashboard: "مشاهده داشبورد",
    delete_files: "حذف فایل ها",
    received_commission: "کمیشن دریافتی",
    paid_commission: "کمیشن پرداختی",
    received_transfer_number: "نمبر حواله",
    receive: "دریافتی",
    send: "ارسالی",
    a2a: "انتقال",
    percentage: "فیصدی",
    deactivated: "حذف شده ها",
    cci: "سه گانه",
    account_statement_of: "صورت حساب",
    balance_sheet_of: "بیلانس شیت",
    with: "همراه",
    business_name: "اسم شرکت",
    view_dashboard: "مشاهده داشبورد",
    delete_files: "حذف فایل ها",
    expose_report: "گزارش پیش خرید",
    balance: "بیلانس",
    save_print: "ثبت و چاپ بیل",
    position: "وظیفه",
    hire_date: "تاریخ استخدام",
    fire_date: "مدت اعتبار",
    salary: "مقدار معاش",
    exchange_results: "خلاصه تبادلات",
    refresh: "تازه سازی",
    print: "چاپ",
    excel: "دانلود فایل",
    full_details_of_receiver: "اطلاعات کامل دریافت کننده",
    full_details_of_sender: "اطلاعات کامل ارسال کننده",
    sender_full_name: "اسم کامل ارسال کننده",
    received_commission: "کمیشن دریافتی",
    paid_commission: "کمیشن پرداختی",
    received_transfer_number: "نمبر حواله دریافتی",
    percentage: "فیصدی کمیشن",
    business_name: "اسم شرکت",
    account_statement: "صورت حساب",
    exchange_income_report: "عواید تبادلات",
    sale_profit: "مفاد فروش",
    buy_profit: "مفاد خرید",
    maximum_amount: "حداکثر مقدار",
    minimum_amount: "حداقل مقدار",
    branches_and_agents: "نمایندگیها/صراف ها",
    saraf: "صراف",
    sarafs: "صراف ها",
    exteranl_accounts: "حسابات بیرونی",
    assets: "دارایی ها",
    sarafs_commission: "کمیشن صرافها",
    gov_id: "Gov-ID",
    customer_type: "نوعیت مشتری",
    establishment_date: "تاریخ تاسیس",
    transactions_count: "تعداد تراکنش ماهانه",
    transactions_amount: "مقدار تراکنش ماهانه",
    organization_chart: "ساختار تشکیلاتی",
    share_amount: "مقدار سهم",
    is_dab: "Dab Auction",
    sign: "امضا",
    pep: "PEP",
    sanction_screening:"Sanction Screening",
    risk_category: "Risk Category",
    suction_checked: "Sanction Screening Checked",
    dab_auction: "DAB Auctions Result",
    position_rank: "رتبه بست",
    join_date: "تاریخ اشتراک",
    resign_date: "ناریخ عدم اشتراک",
    print_org_chart:"چاپ ساختار تشکیلات",
    temporary:"مشتری غیر حقیقی",
    share_percentage:"فیصدی سهام",
    staff_reg:"کارمندان و ساختار تشکیلاتی",
    total_cash_with_banks: "پول نقد در بانک",
    individuals_receivables: "قابل دریافت مشتریان حقیقی (شخصی)",
    individuals_payable: "قابل پرداخت مشتریان حقیقی (شخصی)",
    customers_receivables: "Customers Receivables",
    customers_payable: "Customers Payable",
    staffs_advance_salary_receivables: "قابل در یافت حساب پیش پرداخت کارمندان",
    staffs_salary_payable:"قابل پرداخت برای کارمندان",
    sarafs_receivables:"سایر قابل دریافت ها",
    sarafs_payable:"سایر قابل پرداخت ها",
    sarafs_com_receivables:"Sarafs Com Receivables",
    sarafs_com_payable:"Sarafs Com Payable",
    corporates_receivables:"قابل دریافت مشتریان حکمی (شرکتی)",
    corporates_payable:"قابل پرداخت مشتریان حکمی (شرکتی)",
    shareholders_payable:"مجموع سرمایه سهم شرکاء",
    branch_payable:"قابل پرداخت به نمایندگی های تحت اثر",
    branch_receivables:"قابل حصول از نمایندگی های تحت اثر",
    "Cash In Hand":"پول نقد",
    "Commission Incomes":"کمیشن از درک اجرای حواله",
    "Exchange Incomes":"عواید از درک تبادله اسعار",
    income_statement_from:"صورت حساب مفاد و ضرر از",
    notification_report:"یاد آوری ها",
    customers_overbalanced:"مشتریان با ذمه",
    other_liabilities:"سایر قابل پرداختها",
    current_assets:"دارایی های جاری",
    total_current_assets:"مجموع دارایی های جاری",
    total_fixed_assets:"مجموع دارایی های ثابت",
    current_liabilities:"بدهی های جاری",
    total_capital:"کل سرمایه",
    capital_and_liabilities:"کل سرمایه و بدهی ها",
    all_branches:"همه نمایندگی ها",
    permanent:"مشتری دایمی",
    status:"وضعیت",
    view_chart:"ساختار تشکیلاتی",
    compliance_sign:"امضای کمپلینس",
    low:"کم",
    medium:"متوسط",
    high:"زیاد",
    non_lctr_report:"معاملات تحت معیار",
    links:"لینک ها",
};
